import type { Theme, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import type { Styles } from '@material-ui/core/styles/withStyles';
import { Text, View } from '@zinc/ui';
import type { ComponentProps } from 'react';

type TextVariant = ComponentProps<typeof Text>['variant'];

import withDisplayName from 'bz-utilities/hoc/display-name';

import type { PropsWithChildren, ReactElement } from 'react';

import AccentlessSubHeader from './controls/accentless-sub-header';
import SubHeader from './controls/real-sub-header';
import RoutingTab from './controls/routing-tab';
import Tab from './controls/tab';
import styles from './styles';

export interface IPageHeaderProps extends PropsWithChildren, WithStyles<typeof styles> {
  title: string;
  /** 
    The back button element 
  */
  button?: ReactElement;
  className?: string;
  paddingStart?: number;
  /** Text variant for the title. Defaults to `title-6`. */
  titleVariant?: TextVariant;
}

const PageHeader = withStyles(styles)(
  withDisplayName(function ({
    title,
    button,
    children,
    paddingStart = 3,
    titleVariant = 'title-6'
  }: IPageHeaderProps) {
    return (
      <View
        direction="row"
        align="center"
        backgroundColor="page-faded"
        padding={3}
        paddingStart={paddingStart}
      >
        {button}
        <Text variant={titleVariant} className="capitalize">
          {title}
        </Text>
        <View grow></View>
        {children}
      </View>
    );
  }, 'PageHeader')
);

export default PageHeader;

export { AccentlessSubHeader, PageHeader, RoutingTab, SubHeader, Tab };

export const TabFactory = (style: Styles<Theme, {}, string>) => withStyles(style)(Tab);
export const SubHeaderFactory = (style: Styles<Theme, {}, string>) => withStyles(style)(SubHeader);
export const PageHeaderFactory = (style: Styles<Theme, {}, string>) =>
  withStyles(style)(PageHeader);
